export const validatePwd = function (password) {
  let iNow = 0;
  if (password.match(/\s/)) {
    return false;
  }
  if (password.match(/[\u4E00-\u9FA5]/g)) {
    return false;
  }
  if (password.match(/[0-9]/g)) {
    iNow++;
  }
  if (password.match(/[a-z]/gi)) {
    iNow++;
  }
  if (password.match(/[~!@#$%^&*]/g)) {
    iNow++;
  }
  return iNow >= 2;
};
